<!--
  用户微信扫码后，若未绑定账号，则提示绑定账号
    + 输入手机号和验证码进行绑定，如果手机号存在则直接绑定，不存在则创建账号下一步为设置密码
 -->
<template>
  <div class="bind_account">
    <div class="txt_box">
      <h1>
        <i class="iconfont iconziyuan57"></i>
        <span>请选择是否需要关联账号，以方便完成以下功能</span>
      </h1>
      <ol>
        <li>1.绑定手机账号，避免每次扫码登录</li>
        <li>2.绑定已有iJournal账号，同步个人信息，评论，收藏</li>
      </ol>
    </div>
    <div class="form_wrapper">
      <el-form
        label-position="left"
        hide-required-asterisk
        :model="form"
        :rules="rules"
        ref="form"
        size="small"
        class="form">
        <el-form-item prop="mobile">
          <el-input
            type="text"
            :maxlength="11"
            v-model.trim="form.mobile"
            size="small"
            placeholder="请输入手机号">
          </el-input>
        </el-form-item>
        <el-form-item prop="captchaCode">
          <div class="captcha">
            <el-input class="captcha_input" size="small" placeholder="请输入图形验证码" v-model.trim="captchaCode" />
            <img class="captcha_img" :src="captcha.url" title="点击刷新" alt="" @click="refreshImageCaptcha" />
          </div>
        </el-form-item>
        <el-form-item prop="smsCode">
          <el-input
            size="small"
            placeholder="请输入短信验证码"
            v-model="form.smsCode"
            class="my-el-input__inner-group__append append_primary_plain vertical-align-middle">
            <el-button
              type="primary"
              plain
              slot="append"
              size="small"
              :disabled="!(canGetSms && validateFieldMobile)"
              @click="handleSendSms">{{ sendSmsBtnText }}
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" v-if="existsMobile === 0">
          <el-input
            type="password"
            v-model.trim="form.password"
            size="small"
            placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="btn_wrapper flex flex_direction" style="margin-top: 8px;">
            <el-button type="primary" size="small" :loading="submitBtnLoading" @click="submitBefore">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as api from '~/api'
import SHA256 from 'crypto-js/sha256'
export default {
  data () {
    return {
      // 提交表单button的loading
      submitBtnLoading: false,
      // 发送短信按钮的文字
      sendSmsBtnText: '发送验证码',
      // 是否可以获取短信验证码
      canGetSms: true,
      // 图形验证码
      captchaCode: '',
      captcha: {
        url: '',
        tk: ''
      },
      // 是否存在账号
      existsMobile: 1,
      // 登录信息
      form: {
        // 目前为手机号
        mobile: '',
        // 短信验证码
        smsCode: '',
        // 密码
        password: ''
      },
      // 登录表单验证规则
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { pattern: /^[0-9]{6}$/, message: '验证码格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}$/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // 对手机号进行校验
    validateFieldMobile () {
      if (this.form.mobile && /^1\d{10}$/.test(this.form.mobile)) {
        return true
      }
      return false
    },
    validateCaptchaCode () {
      if (this.captchaCode && /^[a-zA-Z0-9]+$/.test(this.captchaCode)) {
        return true
      }
      this.$message.warning('请输入图形验证码')
      return false
    }
  },
  mounted () {
    this.getImageCaptcha()
  },
  methods: {
    // 获取短信验证码
    handleSendSms () {
      if (!(this.canGetSms && this.validateFieldMobile && this.validateCaptchaCode)) return
      this.canGetSms = false
      api.sendSms({
        mobile: this.form.mobile,
        tk: this.captcha.tk,
        captchaCode: this.captchaCode
      }).then(res => {
        if (res.data.code === 0) {
          let count = 60
          this.sendSmsBtnText = `已发送(${count}s)`
          let interval = setInterval(() => {
            if (count <= 0) {
              clearInterval(interval)
              this.sendSmsBtnText = '发送验证码'
              this.canGetSms = true
            } else {
              count--
              this.sendSmsBtnText = `已发送(${count}s)`
            }
          }, 1000)
          // 是否存在账号 如果不存在账号的话 出现密码框 输入密码
          this.existsMobile = res.data.data.exists
        } else {
          this.$message.error(res.data.message)
          this.canGetSms = true
        }
      }).catch((error) => {
        alert('网络错误，请重试！')
        this.canGetSms = true
        console.log(error)
      })
    },

    // 获取图片验证码
    getImageCaptcha () {
      api.getImageCaptcha().then(res => {
        if (res.data.code === 0) {
          this.captcha = {
            tk: res.data.data.tk,
            url: res.data.data.url + '?w=99&h=33'
          }
          console.log(this.captcha.url)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    // 刷新图片验证码
    refreshImageCaptcha () {
      let dateNow = new Date()
      this.captcha.url = `${this.captcha.url.split('?')[0]}?d=${dateNow.valueOf()}&w=99&h=33`
    },

    // 进行验证
    submitBefore () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.bindAccount()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 绑定账号
    bindAccount () {
      this.submitBtnLoading = true
      api.bindMobile({
        mobile: this.form.mobile,
        smsCode: this.form.smsCode,
        password: this.existsMobile === 0 ? SHA256(this.form.password).toString() : ''
      }).then(res => {
        if (res.data.code === 0) {
          console.log('绑定手机号成功', res.data.data)
          // 重新获取用户信息
          this.getUserInfo()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
        this.submitBtnLoading = false
      })
    },

    // 获取用户信息
    getUserInfo () {
      api.getUserInfo().then(res => {
        if (res.data.code === 0) {
          this.$store.commit('SET_USER_INFO', res.data.data)
          this.$refs['form'].resetFields()
          // 发送登录成功的消息
          this.$bus.emit('loginSuccess')
          // 关闭登录框
          this.$emit('closeDialog')
        } else {
          this.$message.error(res.data.message)
        }
        this.submitBtnLoading = false
      }).catch(err => {
        this.submitBtnLoading = false
        this.$message.error('获取信息失败')
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .bind_account {
    padding: 30px 63px 20px 60px;
    .txt_box {
      & > h1 {
        margin-bottom: 10px;
        & > span {
          font-size:18px;
          font-weight:bold;
          color: #000000;
        }
      }
      & > ol {
        & > li {
          &+li {
            margin-top:6px;
          }
        }
      }
    }
    .form_wrapper {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .form {
        width: 240px;
      }
      .captcha {
        display: flex;
        &_input {
          flex: 1;
        }
        &_img {
          width: 99px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/form-dialog/bind-form.vue